module.exports = __webpack_public_path__ + "static/img/cgy3.bcef70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cgy3.png
// module id = /L9N
// module chunks = 73